import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { isNil } from 'lodash';
// Import Components
import DownloadOrSendToEmailToolbar from 'components/common/DownloadOrSendToEmailToolbar';
import PlayersDataTable from 'components/common/PlayersDataTable';
import SectionWithTitle from 'components/common/SectionWithTitle';
// Import Configs
import { CampaignBonusReceivedPlayersTableConfig } from './config';
// Import Constants
import { l } from 'constants/common';

const CampaignBonusReceivedPlayers = ({
    isLoading,
    data,
    downloadAllClickHandler,
    sendToEmailClickHandler,
    isFileLoading,
}) => {
    const { t } = useTranslation();

    return (
        <SectionWithTitle
            title={t(l.BonusReceivedPlayers)}
            titleContent={
                <DownloadOrSendToEmailToolbar
                    downloadAction={downloadAllClickHandler}
                    sendToEmailAction={sendToEmailClickHandler}
                    isFileLoading={isFileLoading}
                    isDisabledDownload={isNil(data?.Count) || data?.Count === 0}
                />
            }
            hasContentPadding={false}
            className="c-r-s-with-title"
            contentClassName="c-r-s-with-title-content"
        >
            <PlayersDataTable
                key="CampaignExecuteId"
                name={t(l.BonusReceivedPlayers)}
                config={CampaignBonusReceivedPlayersTableConfig}
                isLoading={isLoading}
                data={data}
            />
        </SectionWithTitle>
    );
};

CampaignBonusReceivedPlayers.propTypes = {
    isLoading: PropTypes.bool,
    isFileLoading: PropTypes.bool,
    data: PropTypes.object,
    downloadAllClickHandler: PropTypes.func,
    sendToEmailClickHandler: PropTypes.func,
};

CampaignBonusReceivedPlayers.defaultProps = {
    isLoading: true,
    data: {},
};

export default memo(CampaignBonusReceivedPlayers);
